import { render, staticRenderFns } from "./SettingsUsersView.vue?vue&type=template&id=c107339e&scoped=true&"
import script from "./SettingsUsersView.vue?vue&type=script&lang=js&"
export * from "./SettingsUsersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c107339e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c107339e')) {
      api.createRecord('c107339e', component.options)
    } else {
      api.reload('c107339e', component.options)
    }
    module.hot.accept("./SettingsUsersView.vue?vue&type=template&id=c107339e&scoped=true&", function () {
      api.rerender('c107339e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/users/SettingsUsersView.vue"
export default component.exports